export class DeepLink {
    id: string;
    campaignId: string;
    externalCustomerId: string;
    vatCategoryId: string;
    voucherCode: string;
    vitemID: string;
    createdAt: string;
    updatedAt: string;

    constructor(data: Partial<DeepLink>) {
        this.id = data.id || "";
        this.campaignId = data.campaignId || "";
        this.externalCustomerId = data.externalCustomerId || "";
        this.vatCategoryId = data.vatCategoryId || "";
        this.voucherCode = data.voucherCode || "";
        this.vitemID = data.vitemID || "";
        this.createdAt = data.createdAt || "";
        this.updatedAt = data.updatedAt || "";
    }

    static fromJSON(json: Record<string, any>): DeepLink {
        return new DeepLink(json);
    }
}
